import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  if (!email || !token) {
    window.location.replace('https://turkcedunyasi.com');
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setErrorMessage('');

    if (newPassword.length < 6) {
      setErrorMessage('Şifre en az 6 karakter olmalıdır.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage('Şifreler eşleşmiyor.');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://api.turkcedunyasi.com/api/Login/reset-password', {
        method: 'POST',
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, token, newPassword }),
      });

      if (response.ok) {
        setStatus('success');
      } else {
        const data = await response.json().catch(() => null);
        setErrorMessage(data?.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
        setStatus('error');
      }
    } catch {
      setErrorMessage('Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.');
      setStatus('error');
    }
  }

  if (status === 'success') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successIcon}>✓</div>
          <h2 style={styles.title}>Şifreniz Güncellendi</h2>
          <p style={styles.subtitle}>Yeni şifrenizle giriş yapabilirsiniz.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Türkçe Dünyası <br /> Şifre Sıfırla</h2>
        <p style={styles.subtitle}>Lütfen yeni şifrenizi girin.</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Yeni Şifre</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="En az 6 karakter"
            required
            style={styles.input}
          />

          <label style={styles.label}>Şifre Tekrar</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Şifreyi tekrar girin"
            required
            style={styles.input}
          />

          {errorMessage && <p style={styles.error}>{errorMessage}</p>}

          <button
            type="submit"
            disabled={status === 'loading'}
            style={{
              ...styles.button,
              opacity: status === 'loading' ? 0.7 : 1,
              cursor: status === 'loading' ? 'not-allowed' : 'pointer',
            }}
          >
            {status === 'loading' ? 'Kaydediliyor...' : 'Şifreyi Değiştir'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f0f4f8',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 4px 24px rgba(0,0,0,0.1)',
  },
  title: {
    margin: '0 0 8px',
    fontSize: 22,
    fontWeight: 700,
    color: '#1a202c',
    textAlign: 'center',
  },
  subtitle: {
    margin: '0 0 24px',
    fontSize: 14,
    color: '#718096',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: '#4a5568',
    marginBottom: -4,
  },
  input: {
    padding: '10px 14px',
    borderRadius: 8,
    border: '1px solid #cbd5e0',
    fontSize: 15,
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  button: {
    marginTop: 8,
    padding: '12px',
    borderRadius: 8,
    border: 'none',
    background: '#4f46e5',
    color: '#fff',
    fontSize: 15,
    fontWeight: 600,
  },
  error: {
    margin: 0,
    padding: '10px 14px',
    background: '#fff5f5',
    border: '1px solid #fed7d7',
    borderRadius: 8,
    color: '#c53030',
    fontSize: 14,
  },
  successIcon: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: '#c6f6d5',
    color: '#276749',
    fontSize: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
};
